import axios from 'axios'

export const Five9Transport = axios.create({
  withCredentials: true
})

export class Five9Client {
  constructor(transport = Five9Transport){
    this.transport = transport;
  }

  getSkills(){
    return this.fetchAuthMeta().then((data) => {
      return this.transport
        .get(data.apiUrl+"agents/"+data.userId+"/skills");
    })
    .catch( err => {
      return undefined;
    });
  }

  getCampaigns(){
    return this.fetchAuthMeta().then((data) => {
      return this.transport
        .get(data.apiUrl+"agents/"+data.userId+"/campaigns");
    }).catch( err => {
      return undefined;
    });
  }

  transferToCampaign(callId,campaignId){
    return this.fetchAuthMeta().then((data) => {
      return this.transport
        .post(data.apiUrl+"agents/"+data.userId+"/interactions/calls/"+callId+"/add_campaign_to_conference", { campaignId, warm: false } )
    }).catch( err => {
      return undefined;
    });
  }

  reset(){
    this.authMeta = undefined;
  }

  fetchAuthMeta(){
    if(this.authMeta){
      return this.authMeta;
    }
    this.authMeta = this.transport
      .get("https://app.five9.com/appsvcs/rs/svc/auth/metadata")
      .then( resp => {
        const { orgId, userId } = resp.data;
        const activeDataCenters = resp.data.metadata.dataCenters.filter( d => d.active )
        let apiUrl = undefined;
        if(!!activeDataCenters.length){
          const dataCenter = activeDataCenters[0];
          const dataCenterApiDetails = dataCenter.apiUrls[0];
          const protocol = dataCenterApiDetails.port === "443" ? 'https://' : 'http://';
          apiUrl = `${protocol}${dataCenterApiDetails.host}/appsvcs/rs/svc/`
        }
        return { orgId, userId, apiUrl };
      }).catch( err => {
        return undefined;
      });
    return this.authMeta;
  }

  fetchActiveCalls(){
    return this.fetchAuthMeta().then((data) => {
      return this.transport
        .get(data.apiUrl+"agents/"+data.userId+"/interactions/calls")
    }).catch( err => {
      return undefined;
    });
  }

  fetchCall(callId){
    return this.fetchAuthMeta().then((data) => {
      return this.transport
        .get(data.apiUrl+"agents/"+data.userId+"/interactions/calls/"+callId)
    }).catch( err => {
      return undefined;
    });
  }

  fetchVariable(variableName, variableGroup){
    return this.fetchAuthMeta().then((data) => {
      return this.transport
        .get(data.apiUrl+"orgs/"+data.orgId+"/call_variables")
        .then( resp => {
          const variables = resp.data.filter( d => d.name.toLowerCase() === variableName.toLowerCase() && d.group.toLowerCase() === variableGroup.toLowerCase() )
          if(variables.length == 0){
            return undefined;
          }else{
            return variables[0];
          }
        }).catch( err => {
          return undefined;
        });
      });
  }

  postCallVariable(callId, variableId, value){
    return this.fetchAuthMeta().then((data) => {
      return this.transport
        .put(data.apiUrl+"agents/"+data.userId+"/interactions/calls/"+callId+"/variables", { [variableId]: value })
    }).catch( err => {
      return undefined;
    });
  }

  fetchCallVariable(callId, variableId, value){
    return this.fetchAuthMeta().then((data) => {
      return this.transport
        .get(data.apiUrl+"agents/"+data.userId+"/interactions/calls/"+callId+"/variables/"+variableId)
    }).catch( err => {
      return undefined;
    });
  }
}
